import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import loadData from "../data";
import ErrorBoundary from "@Components/ErrorBoundary";
import useAmberPlus from "../useAmberPlus";

const AmberPlusDesktop = loadable(() => import("./AmberPlusDesktop"), {
  fallback: <FullPageLoader />,
});

const NotFound = loadable(() => import("@Pages/NotFound"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const { isError, isStatus500 } = useAmberPlus(props);

  if (isError) {
    return <NotFound isStatus500={isStatus500} {...props} />;
  }

  return (
    <ErrorBoundary>
      <AmberPlusDesktop {...props} />
    </ErrorBoundary>
  );
};
export { loadData };
